import React from "react";
import { Link, useLocation } from "react-router-dom";
import images from "../../common/images";

const Header = () => {
  const token = localStorage.getItem("userToken");
  let jsonToken = null;
  try {
    jsonToken = token ? JSON.parse(token) : null;
  } catch {
    jsonToken = token;
  }
  const location = useLocation();

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  return (
    <>
      <div className="navbar navbar-expand-lg bg-dark navbar-dark">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand">
            <img src={images.logo} className="img-fluid" alt="img" />
          </Link>
          <button
            className="navbar-toggler collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span> </span>
            <span> </span>
            <span> </span>
          </button>

          <div
            className="collapse navbar-collapse justify-content-between"
            id="navbarCollapse"
          >
            <div className="navbar-nav ml-auto">
              <Link
                to="/"
                className={`nav-item nav-link ${isActive("/") ? "active" : ""}`}
              >
                Home
              </Link>
              <Link
                to="/clubs"
                className={`nav-item nav-link ${isActive("/clubs") ? "active" : ""}`}
              >
                Clubs
              </Link>
              <Link
                to="/artists"
                className={`nav-item nav-link ${isActive("/artists") ? "active" : ""}`}
              >
                Artists
              </Link>
              <Link
                to="/events"
                className={`nav-item nav-link ${isActive("/events") ? "active" : ""}`}
              >
                Events
              </Link>
              <Link
                to="/house-parties"
                className={`nav-item nav-link ${isActive("/house-parties") ? "active" : ""}`}
              >
                House Parties
              </Link>
              <Link
                to="/blog"
                className={`nav-item nav-link ${isActive("/blog") ? "active" : ""}`}
              >
                Blog
              </Link>
              {jsonToken ? (
                <Link
                  to="/profile"
                  className={`nav-item nav-link ${isActive("/profile") ? "active" : ""}`}
                >
                  Profile
                </Link>
              ) : null}
              <Link
                to="/contact"
                className={`nav-item nav-link ${isActive("/contact") ? "active" : ""}`}
              >
                Contact us
              </Link>
              <Link
                to="/about"
                className={`nav-item nav-link ${isActive("/about") ? "active" : ""}`}
              >
                About
              </Link>
              {!jsonToken ? (
                <div className="download-app">
                  <Link
                    to="/signin"
                    className={`nav-item nav-link ${isActive("/signin") ? "active" : ""}`}
                  >
                    Login
                  </Link>
                </div>
              ) : null}
              {/* <div className="download-app">
                <Link to="#" className="nav-item nav-link">
                  Download App
                </Link>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
